var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flat-chip",style:({
		..._vm.styles,
	})},[_vm._t("default",function(){return [_vm._v("NEW")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }